import React, { useEffect, useState } from 'react';

/**
 * HupalupaYoutubeReport: HUPALUPA YouTube kanal teşhisi + TR aile eğlence merkezi
 * pazar araştırması. Route: /r/hupalupa-youtube (ProtectedRoute allowBrandIds, sidebar YOK)
 *
 * Hupalupa platformda GERÇEK bir marka (KIXX'ten farkı bu), o yüzden e-posta izni
 * değil `allowBrandIds` deseni — HupalupaGoReport/HupalupaGoPresentation'daki gibi
 * iki Hupalupa markası da kabul ediliyor (Eğlence + Hupalupa).
 *
 * İçerik statik — API çağrısı yok. Veri 11 Ağu 2026'da YouTube Data API v3'ten
 * (19 kanal / 960 video + Hupalupa'nın 218 videosu) ve Google Ads API'den
 * (reklamı yayınlanan YouTube video id'leri) çekilip HTML'e gömüldü.
 *
 * Rapor iframe içinde çalışır: kendi CSS'i `:root`, `body`, `h1`, `table` gibi
 * global seçiciler taşıyor; srcDoc izolasyonu dashboard'un stilini korur.
 */
export default function HupalupaYoutubeReport() {
  const [html, setHtml] = useState(null);

  useEffect(() => {
    let alive = true;
    import('./hupalupaYoutubeReportHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px;color:#eee">Rapor yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  const fill = { position: 'fixed', inset: 0, width: '100vw', height: '100vh', border: 0 };

  // Yükleme zemini raporun kendi zeminiyle aynı (#0C0D12) — beyaz flaş olmasın.
  if (!html) return <div style={{ ...fill, background: '#0C0D12' }} />;

  return (
    <iframe
      title="HUPALUPA · YouTube Kanal Teşhisi"
      srcDoc={html}
      style={fill}
    />
  );
}
